import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
	},
	computed: {
		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		}

	},

	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});

		$(".ph-toggle").click(function () {
			$('.vo-nav-bar').toggleClass('open-mobblock');
		});

	},

	methods: {

		navbarToggle: function () {

			//$('.main-menu').slideToggle();
			$('.navbar-v1').removeClass('open-by-mob');
			$('.navbar-v1').toggleClass('opnemenu');

		},

		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		}



	}
};

$(window).scroll(function () {
	if ($(this).scrollTop() > 50) {
		$('.navbar-v1').addClass('hideTopNav');
	} else {
		$('.navbar-v1').removeClass('hideTopNav');
	}
});